import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import SvgIcon from "components/Common/SvgIcon";

import { ICON_MAP } from "constants/icons";

import classnames from "classnames";
import "./style.scss";
import { NO_OP_FUNCTION } from "services/helpers";

/**
 * Creates a generic Notification.
 */
class Notification extends PureComponent {
  state = {
    isVisible: true
  };

  handleOnClose = () => {
    const { onClose } = this.props;

    this.setState({
      isVisible: false
    });

    onClose();
  }

  /**
   * Renders the Notification
   * @returns {React.Component}
   */
  render() {
    const { description, notificationType, customClassName } = this.props;
    const { isVisible } = this.state;

    const backgroundColor = {
      backgroundColor: `${ICON_MAP[notificationType].color}10`,
      color: ICON_MAP[notificationType].color
    };

    const className = classnames(
      "Notification",
      {
        "Notification--hidden": !isVisible,
        [customClassName]: customClassName
      }
    );

    return (
      <div className={className} style={backgroundColor}>
        <SvgIcon
          height={20}
          icon={ICON_MAP[notificationType].icon}
          customClassName="Notification__custom-icon"
          fillColor={ICON_MAP[notificationType].color}
        />
        <p className="Notification__description" style={{ color: ICON_MAP[notificationType].color }}>
          {description}
        </p>
        <SvgIcon
          height={15}
          icon="Close"
          customClassName="Notification__close-icon"
          fillColor={ICON_MAP[notificationType].color}
          onClick={this.handleOnClose}
        />

      </div>
    );
  }
}

Notification.propTypes = {
  description: PropTypes.string.isRequired,
  customClassName: PropTypes.string,
  onClose: PropTypes.func,
  notificationType: PropTypes.oneOf(Object.keys(ICON_MAP)).isRequired
};

Notification.defaultProps = {
  customClassName: null,
  onClose: NO_OP_FUNCTION
};

export default Notification;
